enum StorageKeys {
  AuthMechanism = 'auth-mechanism',
  GCIPToken = 'gcip-token',
  GCIPTenantId = 'gcip-tenant-id',
  SAMLRedirect = 'saml-redirect',
}

export { StorageKeys };
